// Intentionally empty for global CSS — `global.css` was moved into
// `Layout.tsx` so it only loads on pages that render `<Layout>`. The
// landing page at `/` uses its own scoped stylesheet and must not inherit
// Layout's `.nav` / `.hero` / etc. class rules.
//
// The site-wide click delegation below covers `cta_click` analytics for
// every anchor pointing at apps.apple.com — landing CTAs, header,
// article-bottom badges, quiz plan, press button, and inline MDX links.

// Self-hosted fonts (replaces a render-blocking third-party Google Fonts
// request; also removes the Google dependency, in keeping with the app's
// privacy-first positioning). Only the weights/styles used in global.css are
// imported here. Fontsource ships per-subset @font-face with unicode-range,
// so the browser downloads only the subsets a page actually needs;
// font-display: swap is the Fontsource default. These are global on purpose —
// the landing page uses Anton/Archivo too — and @font-face rules carry no
// layout classes, so they don't conflict with the scoped-stylesheet note above.
import "@fontsource/dm-sans/400.css"
import "@fontsource/dm-sans/500.css"
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-sans/800.css"
import "./src/styles/fonts.css"
import "@fontsource/jetbrains-mono/400.css"
import "@fontsource/jetbrains-mono/500.css"
import "@fontsource/archivo/400.css"
import "@fontsource/archivo/400-italic.css"
import "@fontsource/archivo/500.css"
import "@fontsource/archivo/600.css"
import "@fontsource/archivo/700.css"

import { installAppStoreClickTracking } from "./src/utils/analytics"

export const onClientEntry = () => {
  installAppStoreClickTracking()
}
